export const ASSET_CANVAS_SQUARE_NODE_SIZE = 480;
export const ASSET_CANVAS_LONG_SIDE_NODE_SIZE = 640;

/** 音频文件卡：与正方形卡同宽，高度按波形播放器重定义，禁止 1:1。 */
export const ASSET_CANVAS_AUDIO_NODE_WIDTH = ASSET_CANVAS_SQUARE_NODE_SIZE;

/** 媒体区高度（不含标题栏）：对齐音效卡播放条密度，宽 480 时横向条。 */
export const ASSET_CANVAS_AUDIO_NODE_HEIGHT = 128;

/** 标签创建节点的卡片比例：与标签图片卡片同规格展示（640×360）。 */
export const ASSET_CANVAS_CREATE_NODE_ASPECT_RATIO = '16 / 9';

const DEFAULT_ASSET_CANVAS_NODE_RATIO = { width: 1, height: 1 };

interface AssetCanvasNodeRatio {
  width: number;
  height: number;
}

interface AssetCanvasNodeDimensions {
  width: number;
  height: number;
}

function parseAssetCanvasNodeRatio(ratio: string | null | undefined): AssetCanvasNodeRatio {
  if (!ratio) return DEFAULT_ASSET_CANVAS_NODE_RATIO;

  const parts = ratio.includes('/') ? ratio.split('/') : ratio.split(':');
  const [width, height] = parts.map((value) => Number(value.trim()));

  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    return DEFAULT_ASSET_CANVAS_NODE_RATIO;
  }

  return { width, height };
}

export function getAssetCanvasNodeDimensions(
  ratio: string | null | undefined
): AssetCanvasNodeDimensions {
  const { width, height } = parseAssetCanvasNodeRatio(ratio);

  if (width === height) {
    return {
      width: ASSET_CANVAS_SQUARE_NODE_SIZE,
      height: ASSET_CANVAS_SQUARE_NODE_SIZE,
    };
  }

  if (width > height) {
    return {
      width: ASSET_CANVAS_LONG_SIDE_NODE_SIZE,
      height: Math.round((ASSET_CANVAS_LONG_SIDE_NODE_SIZE * height) / width),
    };
  }

  return {
    width: Math.round((ASSET_CANVAS_LONG_SIDE_NODE_SIZE * width) / height),
    height: ASSET_CANVAS_LONG_SIDE_NODE_SIZE,
  };
}

export function getAssetCanvasAudioNodeDimensions(): AssetCanvasNodeDimensions {
  return {
    width: ASSET_CANVAS_AUDIO_NODE_WIDTH,
    height: ASSET_CANVAS_AUDIO_NODE_HEIGHT,
  };
}

export function isAssetCanvasAudioMedia(params: {
  mediaKind?: string | null;
  mimeType?: string | null;
}): boolean {
  if (params.mediaKind === 'audio') return true;
  return Boolean(params.mimeType?.toLowerCase().startsWith('audio/'));
}
